import { z } from 'zod'

import { dbEntitySchema } from './system'
import {
  NotificationEmailType,
  NotificationType,
} from '../constants/notification'

export const notificationSchema = dbEntitySchema.extend({
  user: z.string().optional().nullable(),
  managementUser: z.string().optional().nullable(),
  customer: z.string().optional().nullable(),
  prospect: z.string().optional().nullable(),
  type: z.nativeEnum(NotificationType),
  message: z.string(),
  sentCount: z.number().default(1),
  payload: z.record(z.string(), z.any()).optional().nullable(),
  // IN_APP type only
  title: z.string().optional().nullable(),
  content: z.string().optional().nullable(),
  tags: z.array(z.string()).optional().nullable(),
  publishedAt: z.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
})

export const notificationCreateArgsSchema = z.object({
  user: z.string().optional().nullable(),
  managementUser: z.string().optional().nullable(),
  customer: z.string().optional().nullable(),
  prospect: z.string().optional().nullable(),
  type: z.nativeEnum(NotificationType),
  message: z.string(),
  sentCount: z.number().optional().default(1),
  payload: z.record(z.string(), z.any()).optional().nullable(),
  // IN_APP type only
  title: z.string().optional().nullable(),
  content: z.string().optional().nullable(),
  tags: z.array(z.string()).optional().nullable(),
  publishedAt: z.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
})

// Per-type email template data schemas for NotificationEmailType validation
const venueGuestDateSchema = z.object({
  guestName: z.string(),
  date: z.string(),
  venueName: z.string(),
})

export const admissionGroupReservationConfirmationDataSchema =
  venueGuestDateSchema
export const admissionGroupReservationCancelledDataSchema = venueGuestDateSchema
export const admissionGroupReservationCreatedDataSchema = venueGuestDateSchema
export const admissionGroupReservationRequestCreatedDataSchema =
  venueGuestDateSchema

export const admissionGroupsSummaryVenueDataSchema = z.object({
  admissionGroupsPending: z.array(z.any()),
  admissionGroupsClosed: z.array(z.any()),
  reportDateRange: z.string(),
  reportTime: z.string(),
  venueName: z.string(),
})

export const dataExportGenericCompletedDataSchema = z.object({
  dataDownloadUrl: z.string().url(),
  dataExportName: z.string(),
})

export const dataExportGenericFailedDataSchema = z.object({
  dataExportName: z.string(),
})

export const scheduledReportUpcomingEventTicketSummaryVenueDataSchema =
  z.object({
    eventStats: z.any(),
  })

// Schemas for types with no required fields beyond generic data
export const notificationEmailDataGenericSchema = z.record(z.string(), z.any())

export const notificationEmailDataByTypeSchema: Record<
  NotificationEmailType,
  z.ZodTypeAny
> = {
  [NotificationEmailType.ADMISSION_GROUP_RESERVATION_CONFIRMATION_CUSTOMER]:
    admissionGroupReservationConfirmationDataSchema,
  [NotificationEmailType.ADMISSION_GROUP_GUESTLIST_CONFIRMATION_CUSTOMER]:
    admissionGroupReservationConfirmationDataSchema,
  [NotificationEmailType.ADMISSION_GROUP_RESERVATION_CANCELLED_STAFF]:
    admissionGroupReservationCancelledDataSchema,
  [NotificationEmailType.ADMISSION_GROUP_RESERVATION_CREATED_STAFF]:
    admissionGroupReservationCreatedDataSchema,
  [NotificationEmailType.ADMISSION_GROUP_RESERVATION_REQUEST_CREATED_STAFF]:
    admissionGroupReservationRequestCreatedDataSchema,
  [NotificationEmailType.ADMISSION_GROUPS_SUMMARY_VENUE]:
    admissionGroupsSummaryVenueDataSchema,
  [NotificationEmailType.CUSTOMER_CHAT_NEEDS_RESPONSE_STAFF]:
    notificationEmailDataGenericSchema,
  [NotificationEmailType.CONFIRMATION_REQUEST_COMPLETED_STAFF]:
    notificationEmailDataGenericSchema,
  [NotificationEmailType.CONFIRMATION_REQUEST_CUSTOMER_INVITE]:
    notificationEmailDataGenericSchema,
  [NotificationEmailType.DATA_EXPORT_GENERIC_COMPLETED_STAFF]:
    dataExportGenericCompletedDataSchema,
  [NotificationEmailType.DATA_EXPORT_GENERIC_FAILED_STAFF]:
    dataExportGenericFailedDataSchema,
  [NotificationEmailType.EVENT_ATTRIBUTION_LINKS_STAFF]:
    notificationEmailDataGenericSchema,
  [NotificationEmailType.AFFILIATE_ACTIVATED]:
    notificationEmailDataGenericSchema,
  [NotificationEmailType.SCHEDULED_REPORT_UPCOMING_EVENT_TICKET_SUMMARY_VENUE]:
    scheduledReportUpcomingEventTicketSummaryVenueDataSchema,
}
